import { ApiError } from '@adiox/api';

export function loginErrorMessage(error: unknown, identifier: 'email' | 'account' = 'email'): string {
  if (error instanceof ApiError) {
    if (error.status === 401) {
      // One message for a wrong password, an unknown account and a locked one: the server does not tell them apart.
      return identifier === 'account'
        ? 'The account number or password is incorrect, or the account is temporarily locked.'
        : 'The email or password is incorrect, or the account is temporarily locked.';
    }
    if (error.status === 429) {
      return 'Too many attempts. Please wait a minute and try again.';
    }
    return error.message;
  }
  return 'Cannot reach the server. Check your connection and try again.';
}

export function secondStepErrorMessage(error: unknown): string {
  if (error instanceof ApiError) {
    if (error.status === 401) {
      // A wrong code, a reused code, an expired sign-in and a locked account all look the same from outside.
      return 'That code did not work, or the sign-in has expired. Check the code and try again, or start again.';
    }
    if (error.status === 429) {
      return 'Too many attempts. Please wait a minute and try again.';
    }
    return error.message;
  }
  return 'Cannot reach the server. Check your connection and try again.';
}
